import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Popover } from '@radix-ui/react-popover';
import { SelectTrigger } from './trigger';
import { SelectContent } from './content';
import { useSelect } from './use-select';
export function DesktopSelect({ placeholder, value, options, icon: Icon, onChange, clearable = false, emptyState, search, async, multiple, error = false, disabled = false, }) {
    const { isOpen, setOpen, handleClear, handleSelect, isSelected } = useSelect({
        value,
        onChange,
        multiple,
    });
    return (_jsxs(Popover, { open: isOpen, onOpenChange: setOpen, children: [isOpen && (_jsx("div", { className: "fixed inset-0 z-40", onPointerDown: (e) => {
                    e.currentTarget.style.pointerEvents = 'none';
                    setOpen(false);
                } })), _jsx(SelectTrigger, { value: value, placeholder: placeholder, icon: Icon, clearable: clearable, error: error, disabled: disabled, onClear: handleClear }), _jsx(SelectContent, { options: options, emptyState: emptyState, search: search, async: async, isSelected: isSelected, onSelect: handleSelect, onClose: () => setOpen(false) })] }));
}
